import React, { useState } from "react";

export default function BriefingSimples() {
  const [templates, setTemplates] = useState({
    display: { enabled: false, variacoes: "" },
    rich: { enabled: false, variacoes: "" },
    vast: { enabled: false, variacoes: "" },
    dvast: { enabled: false, variacoes: "" },
  });

  const [triggers, setTriggers] = useState([]);
  const [feed, setFeed] = useState("");

  const triggerOptions = [
    "A/B Testing",
    "Browser & Device Targeting",
    "Connection Type Targeting",
    "Day of Week Targeting",
    "Location (Geo) Targeting",
    "Language Targeting",
    "Time of Day Targeting",
    "URL Keyword Targeting",
    "Weather Targeting"
  ];

  const handleTemplateToggle = (key) => {
    setTemplates(prev => ({
      ...prev,
      [key]: { ...prev[key], enabled: !prev[key].enabled }
    }));
  };

  const handleVariacaoChange = (key, value) => {
    setTemplates(prev => ({
      ...prev,
      [key]: { ...prev[key], variacoes: value }
    }));
  };

  const handleTriggerChange = (trigger) => {
    setTriggers(prev => {
      if (prev.includes(trigger)) {
        return prev.filter(t => t !== trigger);
      }
      return [...prev, trigger];
    });
  };

  const inlineStyles = `
  input[type="checkbox"] {
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
  width: auto !important;
  height: auto !important;
  cursor: pointer;
}
.form-grid-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 15px;
}

.force-inline .checkbox-container {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  gap: 20px !important;
  background-color: #f9f9f9;
  padding: 10px !important;
  border-radius: 8px;
  margin-top: 5px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

input, select {
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #ccc;
  width: 100%;
}

h2 {
  margin-bottom: 20px;
}

h3 {
  margin-top: 30px;
}
`;

  return (
    <div className="article-page-container" style={{ padding: 20, maxWidth: 800 }}>
  <style>{inlineStyles}</style>

  <h2>Validador MIQ</h2>

  {/* TEMPLATES */}
  <h3>Templates</h3>
  <div className="form-grid-row">
    {Object.entries(templates).map(([key, item]) => (
      <div key={key}>
        <label className="checkbox-item">
          <input
            type="checkbox"
            checked={item.enabled}
            onChange={() => handleTemplateToggle(key)}
          />
          {key}
        </label>

        {item.enabled && (
          <div style={{ marginTop: 8 }}>
            <input
              type="number"
              placeholder="Número de variações"
              value={item.variacoes}
              onChange={(e) => handleVariacaoChange(key, e.target.value)}
            />

            {item.variacoes > 10 && (
              <p style={{ color: "red", marginTop: 5 }}>
                Máximo de 10 variações permitido
              </p>
            )}
          </div>
        )}
      </div>
    ))}
  </div>

  {/* TRIGGERS */}
  <h3>Triggers</h3>
  <div className="force-inline">
    <div className="checkbox-container">
      {triggerOptions.map(t => (
        <label key={t} className="checkbox-item">
          <input
            type="checkbox"
            checked={triggers.includes(t)}
            onChange={() => handleTriggerChange(t)}
          />
          {t}
        </label>
      ))}
    </div>

    {triggers.length > 3 && (
      <p style={{ color: "red" }}>
        Máximo de 3 triggers permitidos
      </p>
    )}
  </div>

  {/* FEED */}
  <h3>Feed</h3>
  <div className="form-grid-row">
    <select value={feed} onChange={e => setFeed(e.target.value)}>
      <option value="">Selecione</option>
      <option value="JSON">JSON</option>
      <option value="XML">XML</option>
      <option value="CSV">CSV</option>
      <option value="Excel">Excel / Google Sheets</option>
    </select>
  </div>
</div>
  );
}